module.exports = new Function('try {return this===global;}catch(e){return false;}')() // eslint-disable-line no-new-func
